import React from 'react';
import './WhatWeDoBox.css';
import { Link } from 'react-router'
import R from 'ramda';
import {mapIndexed, slugify} from '../resources/utils/utilities';

const whatWeDoBoxText = (item, index) => {
  return (
    <div className='col span-1-of-3 box' key={index}>
      <i className='ion-key icon-big'></i>
      <h3 className='what-we-do-title'>
        <Link to={`courses/${slugify(item.title)}`}>
          {R.prop('title', item)}
        </Link>
      </h3>
      <p>{R.prop('body', item)}</p>
    </div>
  )
}

const WhatWeDoBox = ({item, index}) => {
  const getWhatWeDoBoxTextWithIndex = mapIndexed(whatWeDoBoxText)
  return (
    <div className='row' key={index}>
      {getWhatWeDoBoxTextWithIndex(item)}
    </div>
  )
}

export default WhatWeDoBox;



// WEBPACK FOOTER //
// ./src/components/WhatWeDoBox.js